exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*ios移动端 300ms延迟使用fastclick的错误处理*/\n* {\n  touch-action: manipulation;\n}\n.app {\n  width: 100%;\n  height: 100%;\n}\n.burgeon-spin-fullscreen .demo-spin-icon-load {\n  animation: ani-demo-spin 1s linear infinite;\n}\n@keyframes ani-demo-spin {\nfrom {\n    transform: rotate(0deg);\n}\n50% {\n    transform: rotate(180deg);\n}\nto {\n    transform: rotate(360deg);\n}\n}\n", ""]);

// exports
